module.exports = __webpack_public_path__ + "static/img/bg_goods.a1996a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_goods.png
// module id = aNUY
// module chunks = 1